import { render, staticRenderFns } from "./ProjectStatsWidget.vue?vue&type=template&id=62464f82&scoped=true&"
import script from "./ProjectStatsWidget.vue?vue&type=script&lang=js&"
export * from "./ProjectStatsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatsWidget.vue?vue&type=style&index=0&id=62464f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62464f82",
  null
  
)

export default component.exports